// @ts-check

/**
 * @function checkBooleans
 * @param {object[]} values
 * @returns {void}
 */
export function checkBooleans(...values) {
	values.forEach((value) => {
		if (typeof value !== 'boolean') {
			throw new Error('checkBooleans() has a type error!');
		}
	});
}

/**
 * @function checkStrings
 * @param {object[]} values
 * @returns {void}
 */
export function checkStrings(...values) {
	values.forEach((value) => {
		if (typeof value !== 'string' || !value.length) {
			throw new Error('checkStrings() has a type error!');
		}
	});
}

/**
 * @function checkObject
 * @desc Checks whether an array of objects has a specific structure.
 * @param {object[]} objects The array of objects to check.
 * @throws {Error} Throws an error if any object in the array does not have the expected structure.
 * @returns {void}
 */
export function checkObject(...objects) {
	objects.forEach((value) => {
		const length = Object.keys(value).length;

		const type = value.constructor.name;

		if (length === 0 || type !== 'Object') {
			throw new Error('checkObject() has a type error!');
		}
	});
}

/**
 * @function checkArrayOnlyType
 * @param {object[]} values
 * @returns {void}
 */
export function checkArrayOnlyType(...values) {
	values.forEach((value) => {
		if (!Array.isArray(values)) {
			throw new Error('checkArrayOnlyType() has a type error!');
		}
	});
}

/**
 * @function checkArrayWithLength
 * @param {object[]} values
 * @returns {void}
 */
export function checkArrayWithEmpty(...values) {
	values.forEach((value) => {
		if (!Array.isArray(values) || !values.length) {
			throw new Error('checkArrayWithEmpty() has a type error!');
		}
	});
}

/**
 * @function checkFunctions
 * @param {object[]} values
 * @returns {void}
 */
export function checkFunctions(...values) {
	values.forEach((value) => {
		if (typeof value !== 'function' || value.constructor.name !== 'Function') {
			throw new Error('checkFunction() has a type error!');
		}
	});
}

/**
 * @function checkNumbers
 * @param {object[]} values
 * @returns {void}
 */
export function checkNumbers(...values) {
	values.forEach((value) => {
		if (typeof value !== 'number' || isNaN(value) || !isFinite(value)) {
			throw new Error('checkNumber() has a type error!');
		}
	});
}

/**
 * @function causeError
 * @param {string} errMsg
 * @returns {void}
 */
export function causeError(errMsg) {
	throw new Error(errMsg);
}
